
























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import CreateAvailabilityRestrictionPeriodRequest from '@/models/AvailabilityRestrictionPeriods/CreateAvailabilityRestrictionPeriodRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'AvailabilityPeriodRequestCreate'
})
export default class extends GiganautVueDialog {

  dialog = false;
  startAt ='';
  endAt ='';
  
  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.startAt = '';
      this.endAt = '';
    }
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }
	  
  async save() {  
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new CreateAvailabilityRestrictionPeriodRequest();
    request.startAt = new Date(`${this.startAt}T12:00`)
    request.endAt = new Date(`${this.endAt}T12:00`)
    await WorkerDetailsModule.createAvailabilityRestrictionPeriod(request);
    this.dialog = false;
  }
}
